interface PaginationInfoProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
  isLoading?: boolean;
}

export function PaginationInfo({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  isLoading = false,
}: PaginationInfoProps) {
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  if (isLoading) {
    return (
      <div className="text-sm text-muted-foreground">Cargando...</div>
    );
  }

  return (
    <div className="text-sm text-muted-foreground">
      Mostrando {startItem} - {endItem} de {totalItems} resultados (Página{" "}
      {currentPage} de {totalPages})
    </div>
  );
}
